import { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const DEPRECATION = `* Deprecation Warning`;
const DOCUMENTATION_NOTE = `Documentation:
  https://harmony.homedepot.com/components/core-ui/react
`;

export const useDeprecationWarnng = (message) => {
  const { isLocal } = useContext(ExperienceContext);

  if (!isLocal) return;

  const formattedMessage = `
  ${message}

  Please update your imports.

  `;

  console.warn(DEPRECATION + ':\n\n' + formattedMessage + DOCUMENTATION_NOTE);
};